import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { FilterSearchingBaseViewModel, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ComunidadAutonomaItemResultsViewModel, FilterSearchingTcComunidadAutonomaViewModel } from '../comunidadautonoma.types';
import { ComunidadAutonomaService } from '../comunidadautonoma.service';

@Component({
    selector: 'app-comunidadautonoma-wrapper',
    templateUrl: './comunidadautonoma-wrapper.component.html',
    /* styleUrls: ['./comunidadesautonomas-wrapper.component.scss'],*/
})

export class ComunidadAutonomaWrapperComponent extends ComponentBase implements OnInit {

    visibilitySpinner = false;
    searching = false;

    result: ComunidadAutonomaItemResultsViewModel | null;
    payload?: FilterSearchingTcComunidadAutonomaViewModel;

    edition = false;

    private errorMessageExcel = 'Se ha producido un error en el servidor. Vuelta a intentarlo más tarde';

    constructor(
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private globalService: GlobalService,
        private fb: UntypedFormBuilder,
        private comunidadAutonomaService: ComunidadAutonomaService,
        private router: Router,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {       
        this.createForm();
        this.recoverLastSearch();
    }

    onSearch(payload: FilterSearchingTcComunidadAutonomaViewModel): void {
        if (!payload) {
            return;
        }

        this.payload = { ...payload } as FilterSearchingTcComunidadAutonomaViewModel; // To keep a copy to be used in the lazy search (paginator)

        this.comunidadAutonomaService.getComunidadesAutonomas(payload).subscribe(results => {
            this.result = results;
            this.searching = true;
        });
    }

    createForm() {
        this.form = this.fb.group({
            Descripcion: [null],
            Email: [null],
        });
    }

    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingTcComunidadAutonomaViewModel;
        this.onSearch(payload);
    }

    onReset(): void {
        this.searching = false;
        this.result = null;
        this.comunidadAutonomaService.clearLastSearch();
    }


    onEdit(itemId: number | null): void {
        this.edition = true;
        this.router.navigate(['/mantenimiento/general/comunidadautonoma/edit', itemId]);
    }

    private recoverLastSearch() {
        this.payload = this.comunidadAutonomaService.getLastSearch();
    }


    onExportExcel(): void {
        this.visibilitySpinner = true;
        const model = this.createModel();
        this.comunidadAutonomaService.export(model).subscribe({
            next: res => {
                this.OpenDownloadedFile(res);
                this.visibilitySpinner = false;
            },
            error: () => this.addErrorMessage(this.errorMessageExcel),
        });
    }

    createModel() {
        let model: FilterSearchingTcComunidadAutonomaViewModel = new FilterSearchingTcComunidadAutonomaViewModel();

        Object.assign(model, this.form.value);

        return model;
    }

    exportIsAvailable(): boolean {
        return this.result?.ResultList ? this.result?.ResultList.length > 0 : false;
    }

}
